<template>
  <b-row>
    <b-col cols="12" class="pl-0 pr-0">
      <div>
        <span v-if="path === 'api/user_datas/'" class="h6"><i class="far fa-file fa-lg mr-2"></i> {{ $t('views.documentFiles.indexFirm') }}</span>
        <span v-else class="h6"><i class="far fa-file fa-lg mr-2"></i> {{ $t('views.documentFiles.index') }}</span>
        <div class="float-right"> <button type='button' class="btn btn-info btn-circle btn-sm mt-0 mb-2 mr-0" v-b-tooltip.hover :title="$t('buttons.uploadDocument')" @click="uploadDocument()">
          <i class="fa fa-plus"></i>
        </button></div>
        <div v-if="item.documentFiles.length > 0">
        <table class="table table-hover table-sm table-striped mb-2">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th v-if="path !== 'api/user_datas/'"></th>
            <th></th>
          </tr>
          <tbody>
          <tr v-for="document in item.documentFiles"
              :key="document['@id']">
            <td style="word-break: break-all">
              {{ document['title'] }}
            </td>
            <td style="word-break: break-all">
              {{ document['fileName'] }}
            </td>
            <td>
              {{ $moment(document.createdAt).format('YYYY-MM-DD HH:mm') }}
            </td>
            <td>
              <span v-if="document.idDocumentType">{{ document.idDocumentType.title }}</span>
            </td>
            <td v-if="path !== 'api/user_datas/'">
              <b-form-checkbox
                style="display:inline-block"
                :id="'attachToEmailCheckbox' + document['@id']"
                v-model="document.attachToEmail"
                v-b-tooltip.hover :title="document.attachToEmail === 0 ? $t('global.attachToEmailHoverTrue') : $t('global.attachToEmailHoverTrue')"
                :value="1"
                @input="updateAttachToEmail(document)"
                :unchecked-value="0">
              </b-form-checkbox>
              <span style="display: inline-block">{{$t("global.attachToEmail")}}</span>
            </td>
            <td>
              <button class="float-right btn btn-link fa fa-download fa-lg" v-b-tooltip.hover :title="$t('buttons.downloadDocument')" @click="downloadDocument(document)"></button>
              <button v-if="ableToDeleteDocument" class="float-right btn btn-link fa fa-times fa-lg" v-b-tooltip.hover :title="$t('buttons.delete')" @click="deleteDocument(document['@id'])"></button>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
        <div v-else>
          {{$t('views.documentFiles.list.noDocuments')}}
        </div>
      </div>
    </b-col>
    <UploadDocumentModal :pathType="path" v-model="documentUploaded"></UploadDocumentModal>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import UploadDocumentModal from '@/components/Dashboard/Views/excmdevicemodel/components/UploadDocumentModal/UploadDocumentModal'
import { checkPermission } from '@/utils/checkRoles'
import remove from '@/utils/remove'

export default {
  name: 'DocumentFiles',
  components: {
    UploadDocumentModal
  },
  props: {
    item: {
      required: true
    },
    path: {
      required: true
    },
    fetchData: {
      required: true
    }
  },
  data () {
    return {
      documentUploaded: 0
    }
  },
  watch: {
    documentUploaded: function () {
      if (this.documentUploaded === 1) {
        this.fetchData()
        this.documentUploaded = 0
      }
    }
  },
  computed: {
    ableToDeleteDocument () {
      return checkPermission('documentfiles', 'EXCMDocumentFileDelete')
    }
  },
  methods: {
    downloadDocument (item) {
      new ApiService(item['@id'] + '/download').downloadFile(item.fileName)
    },
    uploadDocument () {
      this.$store.state.modals.uploadDocument.show = 1
      this.$store.state.modals.uploadDocument.path = this.path + getIdFromLink(this.item['@id']) + '/upload_document'
    },
    deleteDocument (id) {
      remove(id + '/delete', () => {
        this.fetchData()
      })
    },
    updateAttachToEmail (item) {
      const response = new ApiService(item['@id']).put({ attachToEmail: item.attachToEmail })
      if (response.status === 200) {
        this.fetchData()
      }
    }
  }
}
</script>
